/**
 * Enable or disable DOM elements.
 */

// disableElement :: Object a -> Object b
export function disableElement(element) {
	element.disabled = true;
    element.classList.add('disabled');
    return element;
};

// enableElement :: Object a -> Object b
export function enableElement(element) {
    element.disabled = false;
    element.classList.remove('disabled');
    return element;
};

// enableElements :: Boolean -> [Object a] -> [Object b]
const enableElements = shouldEnable => elements => {
	elements.map(shouldEnable ? enableElement : disableElement);
};

// enable :: String -> Boolean -> Boolean
export const enable = selector => (shouldEnable = true) => {
    const elements = [].slice.call(document.querySelectorAll(selector));
    enableElements(shouldEnable)(elements);
};

export default { enable, enableElement, disableElement };
